<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app class="navbar">
      <v-list dense>
        <template v-for="(item, i) in items">
          <!-- MENU ITEM -->
          <v-list-item :key="'item_' + i" @click="handleItemClick(item)" :class="{ 'submenu-open': item.submenuOpen }"
            dense>
            <v-list-item-icon>
              <v-icon color="white" style="font-size: 15px">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ item.nama }}
              <!-- <router-link :to="item.route" v-if="item.route">{{ item.nama }}</router-link>
              <span v-else>{{ item.nama }}</span> -->
            </v-list-item-title>
            <v-list-item-action v-if="item.sub_menu">
              <v-icon @click.stop="toggleSubmenu(item)"
                :class="{ 'rotate-90': item.submenuOpen }">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>

          <!-- SUBMENU ITEM -->
          <v-list-item-group v-if="item.submenuOpen" :key="'submenu_group_' + i" class="submenu-group" dense>
            <template v-for="(subItem, j) in item.sub_menu">
              <v-list-item :key="'subItem_' + j" @click="handleSubItemClick(subItem)" dense>
                <v-list-item-icon>
                  <v-icon color="white" style="font-size: 10px;">{{ subItem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ subItem.text }}
                  <!-- <router-link :to="subItem.route" v-if="subItem.route">{{ subItem.text }}</router-link>
                  <span v-else>{{ subItem.text }}</span> -->
                </v-list-item-title>
                <v-list-item-action v-if="subItem.submenu && subItem.submenu.length">
                  <v-icon @click.stop="toggleSubmenu(subItem)"
                    :class="{ 'rotate-90': subItem.submenuOpen }">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>

              <!-- SUBSUBMENU ITEM -->
              <v-list-item-group v-if="subItem.submenuOpen" :key="'submenu_' + i + '_' + j" class="submenu-group2"
                dense>
                <v-list-item v-for="(subSubItem, k) in subItem.submenu" :key="k" @click="navigateAndClose(subSubItem)"
                  dense>
                  <v-list-item-icon>
                    <v-icon color="white" style="font-size: 10px;">mdi-checkbox-blank-circle-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ subSubItem.text }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </template>
          </v-list-item-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="#0e0537f0" dark dense class="navbar">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text" @click="$router.push(home[0].route)" style="cursor: pointer;">{{ title
      }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- Profile icon -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon to="/pengaturan-umum/index-profil-pengguna" v-on="{ ...tooltip }">
            <v-icon dense>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <span>Profile</span>
      </v-tooltip>

      <!-- <v-chip outlined>{{ this.formatTimer() }}</v-chip> -->

      <!-- Logout icon -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn dense icon @click="logout" v-on="{ ...tooltip }">
            <v-icon dense>mdi mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>LogOut <br>{{ this.userlogin }} </span>
      </v-tooltip>
    </v-app-bar>

    <v-main>
      <v-container fluid class="pa-0 m-0">
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app inset color="#0e0537f0" padless>
      <span class="white--text font-weight-regular text-body-2">&copy; 2016 - {{ new Date().getFullYear() }} by DHIVATECH CONSULTINDO</span>
    </v-footer>
  </v-app>
</template>

<script>
import { appendQueryString } from "@/services/checkApiParams.js";
import axios from 'axios';
export default {
  data() {
    return {
      accessToken: "",
      userlogin: '',
      id: this.id,
      drawer: false,
      title: 'SINTACT V2',
      items: [],
      home: [],
      timer: null, // 30 menit dalam detik
      timerInterval: null,

    };
  },
  created() {
    this.user_id = localStorage.getItem('id');
    this.accessToken = localStorage.getItem('token');
    this.leftMenu();
  },
  methods: {
    handleItemClick(item) {
      if (!item.sub_menu || item.sub_menu.length === 0) {
        this.navigateAndClose(item);
      } else {
        item.submenuOpen = !item.submenuOpen;
        // Close other submenus
        this.items.forEach((i) => {
          if (i !== item) {
            i.submenuOpen = false;
            i.sub_menu.forEach((subItem) => {
              subItem.submenuOpen = false;
            });
          }
        });
      }
    },
    handleSubItemClick(subItem) {
      if (!subItem.submenu || subItem.submenu.length === 0) {
        this.navigateAndClose(subItem);
      } else {
        subItem.submenuOpen = !subItem.submenuOpen;
        // Close other submenus
        if (this.items && this.items.sub_menu) {
          const subItem1 = this.items.sub_menu.find((submenu) => submenu.submenuOpen === true);
          if (subItem1) {
            this.items.sub_menu.forEach((i) => {
              if (i !== subItem) {
                i.submenuOpen = false;
                if (i.submenu) {
                  i.submenu.forEach((q) => {
                    q.submenuOpen = false;
                  });
                }
              }
            });
          }
        }
      }
    },
    toggleSubmenu(item) {
      item.submenuOpen = !item.submenuOpen;
      // console.log(item.submenuOpen)
    },
    navigate(item) {
      let targetRoute = item.route;

      if (item.route === '/penerimaan-barang/index-wip' || item.route === '/pengeluaran-barang/index-wip') {
        targetRoute = item.route + '/1';
      }

      this.$router.push(targetRoute);
    },
    navigateAndClose(item) {
      this.navigate(item);
      this.closeAllSubmenus();
      this.drawer = false;
    },
    closeAllSubmenus() {
      this.items.forEach((item) => {
        if (item.submenu) {
          item.submenuOpen = false;
          item.submenu.forEach((subItem) => {
            if (subItem.submenu) {
              subItem.submenuOpen = false;
            }
          });
        }
      });
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem('timer');
      localStorage.removeItem('id');
      this.$router.push("/login");
      this.timer = 0;
      this.saveTimerToLocalStorage();
    },
    async leftMenu() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const baseUrl = `${apiUrl}/user/left-menu`;
        const params = { id_user: this.user_id };
        const newUrl = appendQueryString(baseUrl, params);

        const response = await axios.get(newUrl, {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        });

        this.items = this.convertData(response.data.data);
        this.home = this.convertData(response.data.data);
        this.items.splice(0, 1);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Cek route saat ini sebelum logout
          const currentRoute = this.$route.name;
          if (currentRoute === "wms-layout") {
            console.warn("Token expired di halaman wms-layout, tidak logout otomatis");
            // Bisa juga tampilkan pesan ke user atau trigger refresh token
          } else {
            console.error("Token expired or invalid. Logging out...");
            this.logout();
          }
        }
      }
    },
    convertData(data) {
      return data.map(item => ({
        nama: item.nama,
        icon: item.icon,
        route: item.action,
        submenuOpen: false,
        sub_menu: item.sub_menu ? item.sub_menu.map(subItem => ({
          text: subItem.nama,
          // icon: subItem.icon,
          route: subItem.action,
          submenuOpen: false,
          submenu: subItem.sub_menu ? subItem.sub_menu.map(subSubItem => ({
            text: subSubItem.nama,
            icon: subSubItem.icon,
            route: subSubItem.action,
            submenuOpen: false
          })) : []
        })) : []
      }));
    },
    loadTimerFromLocalStorage() {
      const storedTimer = localStorage.getItem('timer');
      if (storedTimer) {
        this.timer = parseInt(storedTimer);
      }
    },
    saveTimerToLocalStorage() {
      localStorage.setItem('timer', this.timer.toString());
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        this.timer -= 1;
        this.saveTimerToLocalStorage();
        if (this.timer <= 0) {
          clearInterval(this.timerInterval);
          localStorage.removeItem('id');
          localStorage.removeItem('token');
          window.location.reload();
          // this.timer=36*60;
          this.saveTimerToLocalStorage();
          console.log('Timer habis!');
        }
      }, 1000); // 1 detik
    },
    formatTimer() {
      const minutes = Math.floor(this.timer / 60);
      const seconds = this.timer % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
  },
  mounted() {
    this.userlogin = localStorage.getItem('username');
    this.id = localStorage.getItem('id');
    this.loadTimerFromLocalStorage();
    if (this.id) {
      this.startTimer();
    } else {
      localStorage.removeItem('id');
    }
  }
};
</script>

<style scoped>
.navbar {
  background-color: #424a5d;
  color: #ffffff;
}

.submenu-group {
  padding-left: 10px;
  margin-bottom: 5px;
  font-size: 6px;
}

.submenu-group2 {
  margin-bottom: 5px;
  margin-left: 20px;
}

.submenu-open .v-list-item-action {
  transform: rotate(90deg);

}

.v-list-item__title,
.v-list-item-action__icon,
.v-list-item-icon {
  color: #ffffff !important;
  font-size: 12px;
}

.v-list-item-icon .v-icon {
  font-size: 8px !important;
}

.v-list-item__title a {
  color: #ffffff !important;
  text-decoration: none;
  font-size: 12px;
  margin-top: 5px;
  /* padding: 5px 10px; */
}

.v-toolbar-title {
  background-color: #ffd777 !important;
}

.white--text {
  font-weight: 900;
}

.v-list-item:hover,
.v-list-item:hover .v-list-item__title a {
  background-color: #68dff0;
  color: #ffffff !important;
}

.v-list-item:hover .v-list-item-action__icon {
  color: #ffffff !important;
}

.v-list-title {
  /* font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif; */
  font-size: 14px;
}

.white--text {
  font-weight: 900;
}

* {
  font-family: inter-var, sans-serif;
}

.rotate-90 {
  transform: rotate(90deg);
  transition: transform 0.3s;
}
</style>